import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import { alpha } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useRouter } from 'next/router'
import React from 'react'

type Props = {
  product: any
  theme?: string
  /** Sans retrait : dans la colonne de texte d'une ligne de liste */
  flush?: boolean
}

/**
 * Pourquoi ce produit est proposé, quand on peut le dire : déjà pris à cette période, intervalle
 * habituel atteint, pharmacies qui l'achètent aussi, marque nouvelle pour la pharmacie.
 */
const RecommendReason: React.FC<Props> = ({ product, theme, flush = false }) => {
  const router = useRouter()
  const locale = (router.query.locale as string) || 'fr'

  let text: string | null = null
  // Nombre de pharmacies : l'argument social de la proposition, mis en valeur dans une pastille
  let pharmacyCount = false
  if (product.reorder_reason === 'same_period') {
    text = t(
      { id: 'web_reco_same_period' },
      {
        qty: product.reorder_qty,
        month: new Date(product.reorder_reference_ts * 1000).toLocaleDateString(locale, {
          month: 'long',
          year: 'numeric',
        }),
      }
    )
  } else if (product.reorder_reason === 'cadence') {
    text = t(
      { id: 'web_reco_cadence' },
      { interval: product.reorder_interval_days, days: product.reorder_days_since }
    )
  } else if (product.common_buyers) {
    text = t({ id: 'web_reco_common_buyers' }, { count: product.common_buyers })
    pharmacyCount = true
  } else if (theme === 'discovery') {
    text = t({ id: 'web_reco_new_brand' })
  } else if (product.social_proof_buyers) {
    text = t({ id: 'web_reco_social_proof' }, { count: product.social_proof_buyers })
    pharmacyCount = true
  }

  if (!text) return null

  if (pharmacyCount) {
    return (
      <Box sx={{ px: flush ? 0 : 1, pt: 0.5 }}>
        {/* Bleu secondaire de l'enseigne : le primaire (jaune clair sur le thème par défaut) ne se lit
            pas sur fond blanc */}
        <Chip
          size="small"
          icon={<StorefrontOutlinedIcon aria-hidden="true" />}
          label={text}
          sx={{
            height: 20,
            maxWidth: '100%',
            fontSize: 11,
            fontWeight: 600,
            color: 'secondary.main',
            bgcolor: theme => alpha(theme.palette.secondary.main, 0.1),
            '& .MuiChip-icon': { fontSize: 14, ml: 0.75, color: 'secondary.main' },
            '& .MuiChip-label': { px: 0.75 },
          }}
        />
      </Box>
    )
  }

  return (
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', px: flush ? 0 : 1 }}>
      {text}
    </Typography>
  )
}

export default RecommendReason
